import React, {useState} from "react";
import {
    Button, ButtonGroup,
    ClickAwayListener,
    Grow, MenuItem,
    MenuList,
    Paper,
    Popper,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";

const ContactActions = ({drafts, isNew, pendingApproval, handlers, ...props}) => {
    const [openOptions, setOpenOptions] = useState(false);
    const [anchorOptions, setAnchorOptions] = useState(null);

    function handleOpenManageListMenu(event) {
        event.stopPropagation();

        setAnchorOptions(event.currentTarget);
        setOpenOptions(true);
    }

    function handleCloseManageListMenu(_event) {
        setOpenOptions(false);
        setAnchorOptions(null);
    }

    const handleAction = (action) => {
        action();
        handleCloseManageListMenu();
    }

    return (
        <>
            {
                isNew ? <Button onClick={handlers.remove} className="error">
                    <DeleteIcon/>
                </Button> : <ButtonGroup variant="contained" color="primary" aria-label="contained primary button group">
                    <Button onClick={(event) => handlers.notes()}>Notes</Button>
                    <Button onClick={(event) => handlers.changeLog()}>Change Log</Button>
                    {
                        !drafts && <Button
                                aria-controls={openOptions ? 'split-button-menu' : undefined}
                                aria-expanded={openOptions ? 'true' : undefined}
                                aria-haspopup="menu"
                                onClick={handleOpenManageListMenu}
                            >
                                Manage
                                <ArrowDropDownIcon />
                            </Button>
                    }
                    <Popper
                        open={openOptions}
                        anchorEl={anchorOptions}
                        transition
                        disablePortal
                        style={{zIndex: 3, borderColor: "transparent"}}
                    >
                        {({TransitionProps, placement}) => (
                            <Grow
                                {...TransitionProps}
                                style={{
                                    transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                                }}
                            >
                                <Paper>
                                    <ClickAwayListener onClickAway={handleCloseManageListMenu}>
                                        <MenuList id="split-button-menu">
                                            {
                                                pendingApproval ? <>
                                                    <MenuItem onClick={(event) => handleAction(handlers.approve)}>Approve Move</MenuItem>
                                                </> : <>
                                                    <MenuItem onClick={(event) => handleAction(handlers.moveCovered)}>Moved to covered Firm</MenuItem>
                                                    <MenuItem onClick={(event) => handleAction(handlers.moveNonCovered)}>Moved to non covered Firm</MenuItem>
                                                </>
                                            }
                                        </MenuList>
                                    </ClickAwayListener>
                                </Paper>
                            </Grow>
                        )}
                    </Popper>
                    <Button onClick={(event) => handlers.markAsReviewed()}>Mark as Reviewed</Button>
                    <Button onClick={handlers.remove} className="error">
                        <DeleteIcon/>
                    </Button>
                </ButtonGroup>
            }
        </>
    );
}

export default ContactActions;